<template>
  <div>
    <v-container fluid>
      <v-row dense class="pb-1">
        <v-col cols="3">
          <date-range :from.sync="from" :to.sync="to" v-model="dateDisplay" @change="refresh()" option="Last 30 days" hide-details/>
        </v-col>
        <v-col class="text-right pr-2">
          <v-btn icon @click="printHtml('Sales commissions summary', buildReport())"><v-icon>mdi-printer</v-icon></v-btn>
          <v-tooltip bottom open-delay="1000" v-if="company.allowCSVExport">
            <template v-slot:activator="{on}">
              <v-btn icon @click="exportCSV" v-on="on"><v-icon>mdi-download</v-icon></v-btn>
            </template>
            Export as CSV file
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 184px)">
      <span v-html="buildReport()"/>
    </v-card>

  </div>
</template>

<script>
import fileSaver from 'file-saver';
import printHtml from '@/mixins/printHtml'

export default {
  name: 'ReportsSalesRepsSummary',
  mixins: [printHtml],
  data() {
    return {
      from: null,
      to: null,
      dateDisplay: '',
      loading: true,
      report: []
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  async created() {
    this.$emit('name', 'Sales commissions summary')
    if (this.$route.query.from && this.$route.query.to) {
      this.from = this.$route.query.from;
      this.to = this.$route.query.to;
    }
  },
  methods: {
    async refresh() {
      this.loading = true;
      const results = await this.$apiCall(`query ReportsSalesRepsSummary($from:Date!, $to:Date!) {
                                              salesRepSummaryReport(from:$from, to:$to) {
                                                salesRepName,commissionPercent,sales,commission
                                              }
                                            }`,
                                          {from:this.from,to:this.to});
      if (!results.error)
        this.report = results.data.salesRepSummaryReport;
      this.loading = false;
    },

    buildReport() {
      const lines = [
                  `<style>
                    @page {size:portrait}
                    .report {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px}
                    .report th {height:36px;padding:0 16px;vertical-align:middle}
                    .report .spacer {height:18px}
                    .report td {height:36px;padding:0 16px;vertical-align:middle}
                    .report .title {font-size:18px;text-transform:uppercase}
                    .report .sub-title {font-weight:normal;height:inherit;padding-bottom:20px;font-size:14px}
                    .report .header th {border-bottom:1px solid #000;margin-bottom:20px}
                    .report .text-left {text-align:left}
                    .report .text-right {text-align:right}
                    .report .font-weight-bold {font-weight:bold}
                    .report .line-top {border-top:thin solid black}
                  </style>
                   <table class="report">
                     <thead>
                        <tr>
                          <th colspan="6" class="sup-title">${this.company.name}</th>
                        </tr>
                        <tr>
                          <th colspan="6" class="title">
                            Sales commissions summary
                          </th>
                        </tr>
                        <tr>
                           <th colspan="6" class="sub-title">
                            ${this.dateDisplay}
                          </th>
                        </tr>
                        <tr class="header">
                          <th width="50%" class="text-left">Sales Representative</th>
                          <th width="10%" class="text-right">Rate</th>
                          <th width="20%" class="text-right">Comm. sales</th>
                          <th width="20%" class="text-right">Commission</th>
                        </tr>
                      </thead>
                      <tbody>`];

      for (const line of this.report) {
        lines.push(`<tr>
                      <td>${line.salesRepName}</td>
                      <td class="text-right">${this.$number(line.commissionPercent,2)}%</td>
                      <td class="text-right">${this.$number(line.sales,2)}</td>
                      <td class="text-right">${this.$number(line.commission,2)}</td>
                    </tr>`);
      }

      lines.push(`</tbody>`);
      lines.push(`</table>`);
      return lines.join('');
    },

    exportCSV() {
      const lines = [ `"${this.company.name}",,,`,
                      `"Sales commissions summary",,,`,
                      `"${this.dateDisplay}",,,`,
                      `"Sales representative","Rate","Commissionable sales","Commission"`
                    ];
      for (const line of this.report)
        lines.push(`"${line.salesRepName}","${this.$number(line.commissionPercent,2)}","${this.$number(line.sales,2)}","${this.$number(line.commission,2)}"`);

      // Write CSV file
      const blob = new Blob([lines.join('\r\n')], {type: "text/plain;charset=utf-8"});
      fileSaver.saveAs(blob, 'Sales commissions summary.csv');
    }
  }
}
</script>